import { render } from "./ChooseGroupView.vue?vue&type=template&id=33eca052&scoped=true"
import script from "./ChooseGroupView.vue?vue&type=script&lang=js"
export * from "./ChooseGroupView.vue?vue&type=script&lang=js"

import "./ChooseGroupView.vue?vue&type=style&index=0&id=33eca052&lang=stylus&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-33eca052"]])

export default __exports__